import { Download } from 'lucide-react';
import { promptInstall, useCanInstall } from '../lib/install.ts';

/**
 * Bouton d'installation. Il n'apparaît que si le navigateur a signalé que l'application peut être installée,
 * et disparaît une fois l'installation faite ou refusée : pas d'invitation qui ne mène nulle part.
 */
export function InstallButton({ variant }: { variant: 'icon' | 'text' }) {
  const canInstall = useCanInstall();
  if (!canInstall) return null;
  const label = 'Installer l’application';
  return (
    <button
      type="button"
      className={variant === 'icon' ? 'icon-button' : 'install-button'}
      onClick={() => void promptInstall()}
      title={variant === 'icon' ? label : undefined}
    >
      <Download size={variant === 'icon' ? 22 : 20} aria-hidden="true" />
      {variant === 'icon' ? <span className="visually-hidden">{label}</span> : label}
    </button>
  );
}
